import LogoEZGO from "Assets/Logos/logo-ezgo.png";
import MenuItems from "Constants/MenuItems";
import { Location, LocationState } from "history";
import { Menu } from "Models/Menu";
import * as React from "react";
import { connect } from "react-redux";
import { matchPath } from "react-router";
import { Col } from "reactstrap";
import { IAuthenticationState } from "Store/Authentication/AuthenticationActionTypes";
import { IApplicationState } from "Store/Store";
import styles from "./Header.scss";
import MenuItem from "./MenuItem/MenuItem";
import Profile from "./Profile/Profile";

const mapStateToProps = (state: IApplicationState) => ({
    authenticationState: state.authenticationState
});

interface IProps {
    authenticationState: IAuthenticationState;
    location: Location<LocationState>;
}

interface IState {
    authenticationState?: IAuthenticationState;
    location: Location<LocationState>;
}

class Header extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            location: props.location
        };
    }

    private isSelected(menuItem: Menu): boolean {
        return !!matchPath(this.state.location.pathname, menuItem.url);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState | null> {
        if (nextProps.authenticationState !== prevState.authenticationState) {
            return { authenticationState: nextProps.authenticationState };
        }
        else if (nextProps.location !== prevState.location) {
            return { location: nextProps.location };
        }
        return null;
    }

    public render() {
        let companyPictureUrl = LogoEZGO;

        if (this.state.authenticationState && this.state.authenticationState.login) {
            if (this.state.authenticationState.login.user.company) {
                companyPictureUrl = this.state.authenticationState.login.user.company.pictureUrl;
            }
        }
        return (
            <div className={styles.header}>
                <div className={styles.content}  >
                    <Col xs={3} className={styles["no-padding"]}>
                        <img className={styles.logo} src={companyPictureUrl} />
                    </Col>
                    <Col xs={6}>
                        <div className={styles.menuItems}>
                            {MenuItems.MAIN_MENU.map(menu =>
                                <MenuItem
                                    key={menu.key}
                                    item={menu}
                                    selected={this.isSelected(menu)} />
                            )}
                        </div>
                    </Col>
                    <Col xs={3} className={styles["no-padding"]}>
                        <Profile />
                    </Col>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(Header);


// WEBPACK FOOTER //
// ./src/Components/Header/Header.tsx